module.exports = __webpack_public_path__ + "static/media/structure.f45ac328.png";